import { mapActions, mapGetters } from 'vuex';
import Card from '../../components/Card/Card';
import PageTitle from '../../components/Pagetitle/Pagetitle';
import Table from '../../components/Table/Table';
import Button from '../../components/Button/Button';
import Modal from '../../components/Modal/Modal';
import Input from '../../components/Input/Input';
import Label from '../../components/Label/Label';
import GroupTable from '@/components/tables/GroupTable';
import PlaceholderTable from '@/components/tables/PlaceholderTable/PlaceholderTable';
import Context from '@/models/Context';
import Group from '@/models/core/Group';
import Membership from '@/models/core/Membership';

export default {
  name: 'groups',
  components: {
    GroupTable,
    PlaceholderTable,
    PageTitle,
    Card
  },
  props: {},
  data() {
    return {};
  },
  computed: {
    teamGroups: function() {
      if (!this.isLoading) {
        return Group.all();
      } else {
        return null;
      }
    },

    teamMembers: function() {
      if (!this.isLoading) {
        return Membership.query()
          .with('team')
          .with('user')
          .whereHas('team', query => {
            query.where(team => {
              return team.domain === Context.query().first().domain;
            });
          })
          .all();
      } else {
        return null;
      }
    },

    isLoading: function() {
      return this._isLoading();
    }
  },
  beforeMount() {
    this._groups();
    this._members();
    this._topics();
  },
  mounted() {},
  methods: {
    ...mapActions({
      _groups: 'entities/groups/findForTeam',
      _members: 'entities/memberships/findForTeam',
      _topics: 'entities/topics/findForTeam'
    }),
    ...mapGetters({
      _isLoading: 'isLoading'
    })
  }
};
